import React, { useState, useEffect } from "react";

const MiniProgressBar = ({ timeStart, functionSecondsAllocated, isDark = false, top = 5 }) => {
    const [elapsedTime, setElapsedTime] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            const now = Date.now();
            // timeStart is in UTC format, parse it correctly
            let startTimeUTC;
            if (timeStart.includes('Z')) {
                // Already has Z suffix (UTC indicator)
                startTimeUTC = new Date(timeStart);
            } else {
                // Add Z suffix to ensure UTC parsing
                startTimeUTC = new Date(timeStart + 'Z');
            }
            const elapsed = Math.floor((now - startTimeUTC.getTime()) / 1000);
            setElapsedTime(elapsed);
        }, 1000);

        return () => clearInterval(interval);
    }, [timeStart]);

    // Handle case where functionSecondsAllocated is 0 or invalid
    const progressPercentage = functionSecondsAllocated && functionSecondsAllocated > 0 
        ? Math.min((elapsedTime / functionSecondsAllocated) * 100, 100) 
        : 0;
    const isOverTime = functionSecondsAllocated && functionSecondsAllocated > 0 && elapsedTime > functionSecondsAllocated;
    const overagePercentage = isOverTime ? ((elapsedTime - functionSecondsAllocated) / functionSecondsAllocated) * 100 : 0;

    return (
        <div className="position-absolute" style={{ top: top, left: 5, right: 5, zIndex: 5 }}>
            <div className="progress bg-light position-relative" style={{ height: "6px", borderRadius: "3px" }}>
                <div
                    className="progress-bar bg-secondary"
                    role="progressbar"
                    style={{ width: `${progressPercentage}%` }}
                    aria-valuenow={elapsedTime}
                    aria-valuemin="0"
                    aria-valuemax={functionSecondsAllocated}
                ></div>
                {isOverTime && (
                    <div
                        className="progress-bar bg-danger"
                        role="progressbar"
                        style={{ width: `${overagePercentage}%` }}
                    ></div>
                )}
                {/* Tick mark for allocated time */}
                <div
                    style={{
                        position: "absolute",
                        left: `${Math.min(100, (functionSecondsAllocated / elapsedTime) * 100)}%`,
                        top: 0,
                        bottom: 0,
                        width: "1px",
                        backgroundColor: "black",
                    }}
                ></div>
            </div>
        </div>
    );
};

export default MiniProgressBar; 